import type { ClientCrmStatus, ValueOf } from '@/types/common';

export const CLIENT_EXPORT_SCOPE_TYPE = {
  SELECTED: 'SELECTED',
  ALL: 'ALL',
} as const;

export type ClientExportScopeType = ValueOf<typeof CLIENT_EXPORT_SCOPE_TYPE>;

export interface ClientExportScopeFilters {
  status?: ClientCrmStatus;
  agent_id?: number;
  name?: string;
}
